export default {
  STORE_PATH: "company",

  // CONSTS
  IS_LOADING: "IS_LOADING",
  COMPANY: "COMPANY",
  STORM_WARNINGS: "STORM_WARNING",
  COMPANY_DISPLAYS: "COMPANY_DISPLAYS",

  // ACTIONS
  INIT_COMPANY_DATA: "INIT_COMPANY_DATA",
  GET_COMPANY: "GET_COMPANY",
  GET_STORM_WARNINGS: "GET_STORM_WARNINGS",
  GET_COMPANY_DISPLAYS: "GET_COMPANY_DISPLAYS",
  GET_LOCATION_FORECASTS: "GET_LOCATION_FORECASTS",
  GET_STATION_CHARTS: "GET_STATION_CHARTS",
  GET_STORM_WARNING_HISTORY: "GET_STORM_WARNING_HISTORY",
  CREATE_FORECAST_DOCUMENT: "CREATE_FORECAST_DOCUMENT",
}